import { parse, toSeconds } from 'iso8601-duration';
import { formatDuration } from 'date-fns';
export const getRecurranceLabelFromPeriod = (period) => {
    if (period) {
        const parsed = parse(period);
        if (!(parsed.seconds || parsed.minutes || parsed.hours)) {
            const seconds = toSeconds(parsed);
            const secondsAsDays = seconds / (60 * 60 * 24);
            switch (secondsAsDays) {
                case 7:
                    return 'week';
                case 31:
                    return 'month';
                case 365:
                    return 'year';
                default:
                    return formatDuration(parsed);
            }
        }
        else {
            return formatDuration(parsed);
        }
    }
    return undefined;
};
//# sourceMappingURL=getRecurranceLabelFromPeriod.js.map